'use strict';

$(document).ready(function() {
    var isDesktop = function() {
        return (
            $('.submenu-link')
                .parents('.menu-toggleable-left')
                .css('position') !== 'fixed'
        );
    };

    function clearSelectedVoice(el) {
        $($(el).parents('.voce-submenu')[0])
            .children()
            .each(function(i, elem) {
                if ($(elem).hasClass('selected')) {
                    $(elem).removeClass('selected');
                }
            });
        // collapse all sibling voices so aria-expanded reflects the real open/closed state
        $($(el).parents('.voce-submenu')[0])
            .find('.submenu-link')
            .attr('aria-expanded', 'false');
        const voiceName ='.sub-' +$(el).data('value').replace(/\s+/g, '-').toLowerCase();

        $($(voiceName).parents('.voce-submenu')[0]).find('.submenu').each(function() {
            if ($(this).hasClass('showMenu')) {
                $(this).removeClass('showMenu');
            }
        });
    }

    const menuSelectedVoci = $('.voce-submenu[selectedvoice]');

    if (isDesktop()) {
        menuSelectedVoci.each((index, menu) => {
            const selectedVoice = $(menu).attr('selectedvoice');
            var child = $(menu).children();
            child.each((index, voce) => {
                if (index + 1 == selectedVoice) {
                    $(voce).addClass('selected');
                    if($(voce).children().length) {
                        const containerToOpen = $(voce).children()[0];
                        if ($(containerToOpen).data('value')) {
                            const voiceName =
                                '.sub-' +
                                $(containerToOpen)
                                    .data('value')
                                    .toLowerCase();
                            $(voiceName).addClass('showMenu');
                            $(containerToOpen).attr('aria-expanded', 'true');
                        }
                    }
                }
            });
        });
    }

    function openSubmenu(el, e) {
        const $el = $(el);
        const voiceName =
            '.sub-' +
            $el
                .data('value')
                .replace(/\s+/g, '-')
                .toLowerCase();
        if (isDesktop()) {
            clearSelectedVoice(el);
            $(voiceName).addClass('showMenu');
            $el.parent().addClass('selected');
            $el.attr('aria-expanded', 'true');
        } else {
            $(voiceName).addClass('selected');
            $('.top-category').hide();
            var topCategory = $('<div class="nav-item dropdown-item top-category d-lg-none" role="button"></div>');
            var link = $el.clone().removeAttr('aria-expanded');
            const nextColumn = $(voiceName).closest('.menu-column').next().clone();
            topCategory.append(link);
            $(voiceName).append(nextColumn);
            $(voiceName)
                .find('.submenu-back-button')
                .after(topCategory)
                .attr('aria-hidden', 'false');
            $el.attr('aria-expanded', 'true');
            const menuBackButton = $('.menu-back-button');
            menuBackButton.hide();
            menuBackButton
                .parent()
                .parent()
                .addClass('p-0');
            e.preventDefault();
        }
    }

    $('.submenu-link').on('click', function(e) {
        openSubmenu(this, e);
    });

    $('.submenu-link').on('keydown', function(e) {
        if (e.which === 13 || e.which === 32) {
            e.preventDefault();
            openSubmenu(this, e);
        }
    });

    function getFocusable($scope) {
        return $scope
            .find('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]')
            .filter(function() {
                return $(this).attr('tabindex') !== '-1' && $(this).is(':visible');
            });
    }

    function panelValue($panel) {
        var classes = ($panel.attr('class') || '').split(/\s+/);
        for (var i = 0; i < classes.length; i++) {
            if (classes[i].indexOf('sub-') === 0) {
                return classes[i].substring(4);
            }
        }
        return null;
    }

    function reorderPanelFocusables(panelEls) {
        var main = [];
        var cta = [];
        var evidenza = [];
        panelEls.forEach(function(el) {
            var $el = $(el);
            if ($el.closest('.highlight').length) {
                cta.push(el);
            } else if ($el.closest('.highlight-column').length) {
                evidenza.push(el);
            } else {
                main.push(el);
            }
        });
        return main.concat(cta, evidenza);
    }

    function buildFlyoutTabOrder($flyout) {
        var focusables = getFocusable($flyout).toArray();
        var $openPanel = $flyout
            .find('.dropdown-submenu.showMenu, .submenu.showMenu')
            .filter(':visible')
            .first();
        if (!$openPanel.length) {
            return focusables;
        }
        var panelEls = reorderPanelFocusables(getFocusable($openPanel).toArray());
        if (!panelEls.length) {
            return focusables;
        }

        var value = panelValue($openPanel);
        var voceEl = null;
        if (value) {
            $flyout.find('.submenu-link').each(function() {
                var slug = String($(this).data('value') || '')
                    .replace(/\s+/g, '-')
                    .toLowerCase();
                if (slug === value) {
                    voceEl = this;
                    return false;
                }
            });
        }

        var rest = focusables.filter(function(el) {
            return panelEls.indexOf(el) === -1;
        });
        var insertAt = voceEl ? rest.indexOf(voceEl) : -1;
        if (insertAt === -1) {
            return focusables;
        }
        return rest.slice(0, insertAt + 1).concat(panelEls, rest.slice(insertAt + 1));
    }

    function focusableOutside(scopeEl, direction) {
        var all = getFocusable($(document)).toArray();
        if (direction === 'next') {
            for (var i = 0; i < all.length; i++) {
                if (!scopeEl.contains(all[i]) && (scopeEl.compareDocumentPosition(all[i]) & 4)) {
                    return all[i];
                }
            }
        } else {
            for (var j = all.length - 1; j >= 0; j--) {
                if (!scopeEl.contains(all[j]) && (scopeEl.compareDocumentPosition(all[j]) & 2)) {
                    return all[j];
                }
            }
        }
        return null;
    }

    $(document).on(
        'keydown',
        '.primary-menu .dropdown-menu .submenu-link, .primary-menu .dropdown-menu a[href], .primary-menu .dropdown-menu button, .primary-menu .dropdown-menu [tabindex="0"]',
        function(e) {
            if (e.which !== 9 || !isDesktop()) {
                return;
            }
            var $flyout = $(this).closest('.dropdown-menu');
            if (!$flyout.length) {
                return;
            }
            var order = buildFlyoutTabOrder($flyout);
            var idx = order.indexOf(this);
            if (idx === -1) {
                return;
            }
            var target;
            if (e.shiftKey) {
                target = idx > 0 ? order[idx - 1] : focusableOutside($flyout[0], 'prev');
            } else {
                target = idx < order.length - 1 ? order[idx + 1] : focusableOutside($flyout[0], 'next');
            }
            if (target) {
                e.preventDefault();
                target.focus();
            }
        }
    );

    $('.submenu-back-button').on('click', function(e) {
        const voiceName = $(this).closest('.submenu');
        if (!isDesktop()) {
            $(voiceName).removeClass('selected');
            $(voiceName)
                .siblings('.submenu-link')
                .attr('aria-expanded', 'false');
            $(voiceName).children().last().remove();
            const topCategory = $('.submenu-back-button').next('.top-category');
            topCategory.html('');
            $('.top-category').show();
            $('.menu-back-button').show();
            $('.menu-back-button')
                .parent()
                .parent()
                .removeClass('p-0');
            e.preventDefault();
        }
    });

    $('.menu-back-button').on('click', function(e) {
        if (!isDesktop()) {
            const topCategory = $('.submenu-back-button').next('.top-category');
            topCategory.remove();
            $('.old').remove();
            e.preventDefault();
        }
    });
});
